export type Vocabulary = { [key: string]: string };

export type DictionaryKeys = {
  APP_HEADER_TITLE: string;
  APP_HEADER_DESC: string;
  APP_HEADER_BULK_UPLOAD_BUTTON: string;
  APP_FOOTER_ADD_PROJECT_BUTTON: string;
  APP_FOOTER_ADD_PROJECT_EXCEED_MAX_OLIGO_HINT: string;
  APP_FOOTER_ADD_TO_CART_BUTTON: string;
  APP_FOOTER_ADD_TO_CART_EXCEED_MAX_OLIGO_HINT: string;
  APP_FOOTER_ADD_TO_CART_INVALID_OLIGO_HINT: string;
  APP_FOOTER_TOTAL_PRICE_TITLE: string;
  APP_FOOTER_OLIGO_COUNT_TITLE: string;
  APP_PLATE_OLIGO_CARD_TEXT: string;
  APP_VALUE_OLIGO_CARD_TEXT: string;
  APP_SUPPORT_CARD_TEXT: string;
  APP_PLATE_OLIGO_CARD_LINK_TEXT: string;
  APP_VALUE_OLIGO_CARD_LINK_TEXT: string;
  CONFIG_SAMPLE_LABEL_LINK_TEXT: string;
  CONFIG_MIXED_BASED_LINK_TEXT: string;
  CONFIG_BASE_COUNT: string;
  CONFIG_MIN_YIELD: string;
  CONFIG_PRICE_TITLE: string;
  CONFIG_PRICE_DESC: string;
  CONFIG_SHOW_MORE_OPTION_LINK_TEXT: string;
  CONFIG_SHOW_LESS_OPTION_LINK_TEXT: string;
  CONFIG_COLLAPSED_UNNANMED_OLIGO: string;
  CONFIG_COLLAPSED_UNNANMED_RESEARCHER: string;
  CONFIG_COLLAPSED_SEQUENCE: string;
  CONFIG_COLLAPSED_EMPTY_SEQUENCE: string;
  PROJECT_HEADER_TITLE: string;
  PROJECT_HEADER_PREFERENCE_BUTTON: string;
  PROJECT_FOOTER_ADD_OLIGO_BUTTON: string;
  PROJECT_FOOTER_ADD_OLIGO_EXCEED_MAX_OLIGO_HINT: string;
  PROJECT_DELETE_POPOVER_TITLE: string;
  PROJECT_DELETE_POPOVER_DESC: string;
  PROJECT_DELETE_POPOVER_OK_BUTTON: string;
  PROJECT_DELETE_POPOVER_CANCEL_BUTTON: string;
  PROJECT_PREFERENCE_POPOVER_TITLE: string;
  PROJECT_PREFERENCE_POPOVER_APPLY_BUTTON: string;
  PROJECT_OLIGO_IMPORT_MODAL_TITLE: string;
  PROJECT_OLIGO_IMPORT_MODAL_OK_BUTTON: string;
  PROJECT_OLIGO_IMPORT_MODAL_CANCEL_BUTTON: string;
  PROJECT_OLIGO_IMPORT_MODAL_DOWNLOAD_TEMPLATE_LABEL: string;
  PROJECT_OLIGO_IMPORT_MODAL_UPLOAD_FILE_LABEL: string;
  PROJECT_OLIGO_IMPORT_MODAL_ERROR_ACCEPT_LABEL: string;
  PROJECT_OLIGO_IMPORT_MODAL_SHOW_PREFERENCES_LABEL: string;
  PROJECT_OLIGO_IMPORT_MODAL_HIDE_PREFERENCES_LABEL: string;
  PROJECT_OLIGO_IMPORT_MODAL_DRAG_AREA_INSTRUCTIONS: string;
  PROJECT_OLIGO_IMPORT_MODAL_TOP_LEVEL_INSTRUCTIONS: string;
  PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_LABEL: string;
  PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_MAX_LABEL: string;
  PROJECT_OLIGO_IMPORT_MODAL_OLIGO_SAMPLE_DATA_LABEL: string;
  PROJECT_OLIGO_IMPORT_MODAL_OLIGO_PREFERENCE_HINT_LABEL: string;
  PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_MAX_REACHED_TEXT: string;
  PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_EMPTY_TEXT: string;
  PROJECT_OLIGO_IMPORT_MODAL_MULTIPLE_FILES_UNSUPPORTED_TEXT: string;
  PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_EXTENSION_UNSUPPORTED_TEXT: string;
  PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_TEXT: string;
  PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_OK_LABEL: string;
  PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_CANCEL_LABEL: string;
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_OK_LABEL: string;
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_CANCEL_LABEL: string;
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_TEXT: string;
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_MISSING_REQUIRED_ONLY_TEXT: string;
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_CONFIG_INCORRECT_TEXT: string;
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_TEXT: string;
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_MISSING_REQUIRED_ONLY_TEXT: string;
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_CONFIG_INCORRECT_ONLY_TEXT: string;
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ERROR_REGION_LABEL: string;
  PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_OK_LABEL: string;
  PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_CANCEL_LABEL: string;
  PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_TEXT: string;
  CONFIG_OLIGO_DELETE_POPOVER_TITLE: string;
  CONFIG_OLIGO_DELETE_POPOVER_DESC: string;
  CONFIG_OLIGO_DELETE_POPOVER_OK_BUTTON: string;
  CONFIG_OLIGO_DELETE_POPOVER_CANCEL_BUTTON: string;
  CONFIG_TAT_SHIP_BY: string;
  CONFIG_TAT_CUTOFF: string;
  CONFIG_SCROLL_TO_VIEW_TEXT: string;
  LOADING_RETRIEVE_PRICE_DESC: string;
  LOADING_VALIDATE_CONFIG_DESC: string;
  MSG_INVALID_BASES: string;
  MSG_MIN_SEQ: string;
  MSG_MAX_SEQ: string;
  MIXED_BASE_POPOVER_OK_LABEL: string;
  MIXED_BASE_POPOVER_TITLE: string;
  MIXED_BASE_POPOVER_DESC: string;
  MIXED_BASE_POPOVER_DISCLAIMER_TITLE: string;
  MIXED_BASE_POPOVER_DISCLAIMER_TPL: string;
  MIXED_BASE_PANEL_DISCLAIMER_LABEL: string;
  TEMPLATE_COL_HEADER_OLIGO_NAME: string;
  TEMPLATE_COL_HEADER_OLIGO_SEQUENCE: string;
  TEMPLATE_COL_HEADER_RESEARCHER_NAME: string;
  TEMPLATE_COL_HEADER_SCALE: string;
  TEMPLATE_COL_HEADER_PRIME_5_MOD: string;
  TEMPLATE_COL_HEADER_PRIME_3_MOD: string;
  TEMPLATE_COL_HEADER_PURIFICATION: string;
  TEMPLATE_COL_HEADER_SPECIAL_HANDLING: string;
  ERROR_MISSING_REQUIRED_GENERIC_MESSAGE: string;
  ERROR_MISSING_REQUIRED_RESEARCHER_NAME_ONLY: string;
  ERROR_MISSING_REQUIRED_OLIGO_RESEARCHER_NAME_ONLY: string;
  ERROR_MISSING_REQUIRED_SEQUENCE_ONLY: string;
  ERROR_MISSING_REQUIRED_OLIGO_NAME_ONLY: string;
  ERROR_INCORRECT_CONFIGURATION: string;
  APP_SUPPORT_EMAIL: string;
  PROJECT_FOOTER_No_OF_OLIGO_LABEL: string;
  ERROR_INVALID_CONFIGURATION: string;
  CONFIG_OLIGO_NAME_PLACEHOLDER: string;
  CONFIG_RESEARCHER_NAME_PLACEHOLDER: string;
  CONFIG_OLIGO_SEQUENCE_PLACEHOLDER: string;
  TOOLTIP_TEXT_SCALE_DROPDOWN: string;
  TOOLTIP_TEXT_PURIFICATION_DROPDOWN: string;
  NOTIFICATION_HEADER: string;
  SESSION_EXPIRED_MSG: string;
  SIGN_IN_OK_LABEL: string;
  UNABLE_TO_FULFIL_REQUEST_MSG: string;
};

export const DictionaryKeys: DictionaryKeys = {
  APP_HEADER_TITLE: 'APP_HEADER_TITLE',
  APP_HEADER_DESC: 'APP_HEADER_DESC',
  APP_HEADER_BULK_UPLOAD_BUTTON: 'APP_HEADER_BULK_UPLOAD_BUTTON',
  APP_FOOTER_ADD_PROJECT_BUTTON: 'APP_FOOTER_ADD_PROJECT_BUTTON',
  APP_FOOTER_ADD_PROJECT_EXCEED_MAX_OLIGO_HINT: 'APP_FOOTER_ADD_PROJECT_EXCEED_MAX_OLIGO_HINT', // v3 mapped
  APP_FOOTER_ADD_TO_CART_BUTTON: 'APP_FOOTER_ADD_TO_CART_BUTTON',
  APP_FOOTER_ADD_TO_CART_EXCEED_MAX_OLIGO_HINT: 'APP_FOOTER_ADD_TO_CART_EXCEED_MAX_OLIGO_HINT', // v3 mapped
  APP_FOOTER_ADD_TO_CART_INVALID_OLIGO_HINT: 'APP_FOOTER_ADD_TO_CART_INVALID_OLIGO_HINT', // v3 mapped
  APP_FOOTER_TOTAL_PRICE_TITLE: 'APP_FOOTER_TOTAL_PRICE_TITLE',
  APP_FOOTER_OLIGO_COUNT_TITLE: 'APP_FOOTER_OLIGO_COUNT_TITLE',
  APP_PLATE_OLIGO_CARD_TEXT: 'APP_PLATE_OLIGO_CARD_TEXT',
  APP_VALUE_OLIGO_CARD_TEXT: 'APP_VALUE_OLIGO_CARD_CONTENT',
  APP_SUPPORT_CARD_TEXT: 'APP_SUPPORT_CARD_TEXT',
  APP_PLATE_OLIGO_CARD_LINK_TEXT: 'APP_PLATE_OLIGO_CARD_LINK_TEXT',
  APP_VALUE_OLIGO_CARD_LINK_TEXT: 'APP_VALUE_OLIGO_CARD_LINK_TEXT',
  CONFIG_SAMPLE_LABEL_LINK_TEXT: 'CONFIG_SAMPLE_LABEL_LINK_TEXT',
  CONFIG_MIXED_BASED_LINK_TEXT: 'CONFIG_MIXED_BASED_LINK_TEXT',
  CONFIG_SHOW_MORE_OPTION_LINK_TEXT: 'CONFIG_SHOW_MORE_OPTION_LINK_TEXT',
  CONFIG_SHOW_LESS_OPTION_LINK_TEXT: 'CONFIG_SHOW_LESS_OPTION_LINK_TEXT',
  CONFIG_COLLAPSED_UNNANMED_OLIGO: 'CONFIG_COLLAPSED_UNNANMED_OLIGO',
  CONFIG_COLLAPSED_UNNANMED_RESEARCHER: 'CONFIG_COLLAPSED_UNNANMED_RESEARCHER',
  CONFIG_COLLAPSED_SEQUENCE: 'CONFIG_COLLAPSED_SEQUENCE',
  CONFIG_COLLAPSED_EMPTY_SEQUENCE: 'CONFIG_COLLAPSED_EMPTY_SEQUENCE',
  CONFIG_BASE_COUNT: 'CONFIG_BASE_COUNT',
  CONFIG_MIN_YIELD: 'CONFIG_MIN_YIELD',
  CONFIG_PRICE_TITLE: 'CONFIG_PRICE_TITLE',
  CONFIG_PRICE_DESC: 'CONFIG_PRICE_DESC',
  PROJECT_HEADER_TITLE: 'PROJECT_HEADER_TITLE',
  PROJECT_HEADER_PREFERENCE_BUTTON: 'PROJECT_HEADER_PREFERENCE_BUTTON',
  PROJECT_FOOTER_ADD_OLIGO_BUTTON: 'PROJECT_FOOTER_ADD_OLIGO_BUTTON',
  PROJECT_FOOTER_ADD_OLIGO_EXCEED_MAX_OLIGO_HINT: 'PROJECT_FOOTER_ADD_OLIGO_EXCEED_MAX_OLIGO_HINT', // v3 mapped
  PROJECT_DELETE_POPOVER_TITLE: 'PROJECT_DELETE_POPOVER_TITLE',
  PROJECT_DELETE_POPOVER_DESC: 'PROJECT_DELETE_POPOVER_DESC',
  PROJECT_DELETE_POPOVER_OK_BUTTON: 'PROJECT_DELETE_POPOVER_OK_BUTTON',
  PROJECT_DELETE_POPOVER_CANCEL_BUTTON: 'PROJECT_DELETE_POPOVER_CANCEL_BUTTON',
  PROJECT_PREFERENCE_POPOVER_TITLE: 'PROJECT_PREFERENCE_POPOVER_TITLE',
  PROJECT_PREFERENCE_POPOVER_APPLY_BUTTON: 'PROJECT_PREFERENCE_POPOVER_APPLY_BUTTON',
  PROJECT_OLIGO_IMPORT_MODAL_TITLE: 'PROJECT_OLIGO_IMPORT_MODAL_TITLE', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_OK_BUTTON: 'PROJECT_OLIGO_IMPORT_MODAL_OK_BUTTON', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_CANCEL_BUTTON: 'PROJECT_OLIGO_IMPORT_MODAL_CANCEL_BUTTON', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_DOWNLOAD_TEMPLATE_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_DOWNLOAD_TEMPLATE_LABEL', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_UPLOAD_FILE_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_UPLOAD_FILE_LABEL', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_ERROR_ACCEPT_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_ERROR_ACCEPT_LABEL', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_SHOW_PREFERENCES_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_SHOW_PREFERENCES_LABEL', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_HIDE_PREFERENCES_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_HIDE_PREFERENCES_LABEL', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_DRAG_AREA_INSTRUCTIONS: 'PROJECT_OLIGO_IMPORT_MODAL_DRAG_AREA_INSTRUCTIONS', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_TOP_LEVEL_INSTRUCTIONS: 'PROJECT_OLIGO_IMPORT_MODAL_TOP_LEVEL_INSTRUCTIONS', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_LABEL', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_MAX_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_MAX_LABEL', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_OLIGO_SAMPLE_DATA_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_OLIGO_SAMPLE_DATA_LABEL', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_OLIGO_PREFERENCE_HINT_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_OLIGO_PREFERENCE_HINT_LABEL', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_MAX_REACHED_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_OLIGO_COUNT_MAX_REACHED_TEXT', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_EMPTY_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_EMPTY_TEXT', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_MULTIPLE_FILES_UNSUPPORTED_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_MULTIPLE_FILES_UNSUPPORTED_TEXT', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_EXTENSION_UNSUPPORTED_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_EXTENSION_UNSUPPORTED_TEXT', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_TEXT', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_OK_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_OK_LABEL', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_CANCEL_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_TEMPLATE_DATA_OVERWRITE_CANCEL_LABEL', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_OK_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_OK_LABEL', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_CANCEL_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_CANCEL_LABEL', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_TEXT', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_MISSING_REQUIRED_ONLY_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_MISSING_REQUIRED_ONLY_TEXT', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_CONFIG_INCORRECT_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_CONFIG_INCORRECT_TEXT', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_TEXT', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_MISSING_REQUIRED_ONLY_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_MISSING_REQUIRED_ONLY_TEXT', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_CONFIG_INCORRECT_ONLY_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_INSTRUCTION_CONFIG_INCORRECT_ONLY_TEXT', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ERROR_REGION_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ERROR_REGION_LABEL', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_OK_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_OK_LABEL', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_CANCEL_LABEL: 'PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_CANCEL_LABEL', // v3 mapped
  PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_TEXT: 'PROJECT_OLIGO_IMPORT_MODAL_DATA_OVERWRITE_TEXT', // v3 mapped
  CONFIG_OLIGO_DELETE_POPOVER_TITLE: 'CONFIG_OLIGO_DELETE_POPOVER_TITLE',
  CONFIG_OLIGO_DELETE_POPOVER_DESC: 'CONFIG_OLIGO_DELETE_POPOVER_DESC',
  CONFIG_OLIGO_DELETE_POPOVER_OK_BUTTON: 'CONFIG_OLIGO_DELETE_POPOVER_OK_BUTTON',
  CONFIG_OLIGO_DELETE_POPOVER_CANCEL_BUTTON: 'CONFIG_OLIGO_DELETE_POPOVER_CANCEL_BUTTON',
  CONFIG_TAT_SHIP_BY: 'CONFIG_TAT_SHIPBY',
  CONFIG_TAT_CUTOFF: 'CONFIG_TAT_COUNTDOWN',
  CONFIG_SCROLL_TO_VIEW_TEXT: 'CONFIG_SCROLL_TO_VIEW_TEXT', // v3 mapped
  LOADING_RETRIEVE_PRICE_DESC: 'LOADING_RETRIEVE_PRICE_DESC',
  LOADING_VALIDATE_CONFIG_DESC: 'LOADING_VALIDATE_CONFIG_DESC',
  MSG_INVALID_BASES: 'CONFIG_OLIGO_INVALID_BASE_PAIR',
  MSG_MIN_SEQ: 'MSG_MIN_SEQ',
  MSG_MAX_SEQ: 'MSG_MAX_SEQ',
  MIXED_BASE_POPOVER_OK_LABEL: 'MIXED_BASE_POPOVER_OK', // v3 mapped
  MIXED_BASE_POPOVER_TITLE: 'MIXED_BASE_POPOVER_TITLE',
  MIXED_BASE_POPOVER_DESC: 'MIXED_BASE_POPOVER_DESC',
  MIXED_BASE_POPOVER_DISCLAIMER_TITLE: 'MIXED_BASE_POPOVER_DISCLAIMER_TITLE',
  MIXED_BASE_POPOVER_DISCLAIMER_TPL: 'MIXED_BASE_POPOVER_DISCLAIMER_TPL',
  MIXED_BASE_PANEL_DISCLAIMER_LABEL: 'MIXED_BASE_PANEL_DISCLAIMER_LABEL',
  TEMPLATE_COL_HEADER_OLIGO_NAME: 'TEMPLATE_COL_HEADER_OLIGO_NAME', // v3 mapped
  TEMPLATE_COL_HEADER_OLIGO_SEQUENCE: 'TEMPLATE_COL_HEADER_OLIGO_SEQUENCE', // v3 mapped
  TEMPLATE_COL_HEADER_RESEARCHER_NAME: 'TEMPLATE_COL_HEADER_RESEARCHER_NAME', // v3 mapped
  TEMPLATE_COL_HEADER_SCALE: 'TEMPLATE_COL_HEADER_SCALE', // v3 mapped
  TEMPLATE_COL_HEADER_PRIME_5_MOD: 'TEMPLATE_COL_HEADER_PRIME_5_MOD', // v3 mapped
  TEMPLATE_COL_HEADER_PRIME_3_MOD: 'TEMPLATE_COL_HEADER_PRIME_3_MOD', // v3 mapped
  TEMPLATE_COL_HEADER_PURIFICATION: 'TEMPLATE_COL_HEADER_PURIFICATION', // v3 mapped
  TEMPLATE_COL_HEADER_SPECIAL_HANDLING: 'TEMPLATE_COL_HEADER_SPECIAL_HANDLING', // v3 mapped
  ERROR_MISSING_REQUIRED_GENERIC_MESSAGE: 'ERROR_MISSING_REQUIRED_GENERIC_MESSAGE', // v3 mapped
  ERROR_MISSING_REQUIRED_RESEARCHER_NAME_ONLY: 'ERROR_MISSING_REQUIRED_RESEARCHER_NAME_ONLY', // v3 mapped
  ERROR_MISSING_REQUIRED_OLIGO_RESEARCHER_NAME_ONLY: 'ERROR_MISSING_REQUIRED_OLIGO_RESEARCHER_NAME_ONLY', // v3 mapped
  ERROR_MISSING_REQUIRED_SEQUENCE_ONLY: 'ERROR_MISSING_REQUIRED_SEQUENCE_ONLY', // v3 mapped
  ERROR_MISSING_REQUIRED_OLIGO_NAME_ONLY: 'ERROR_MISSING_REQUIRED_OLIGO_NAME_ONLY', // v3 mapped
  ERROR_INCORRECT_CONFIGURATION: 'PROJECT_OLIGO_IMPORT_MODAL_CONFIRM_ALERT_CONFIG_INCORRECT_ONLY_TEXT', // v3 mapped
  APP_SUPPORT_EMAIL: 'APP_SUPPORT_EMAIL',
  PROJECT_FOOTER_No_OF_OLIGO_LABEL: 'PROJECT_FOOTER_No_OF_OLIGO_LABEL',
  ERROR_INVALID_CONFIGURATION: 'ERROR_INVALID_CONFIGURATION',
  CONFIG_OLIGO_NAME_PLACEHOLDER: 'CONFIG_OLIGO_NAME_PLACEHOLDER',
  CONFIG_RESEARCHER_NAME_PLACEHOLDER: 'CONFIG_RESEARCHER_NAME_PLACEHOLDER',
  CONFIG_OLIGO_SEQUENCE_PLACEHOLDER: 'CONFIG_OLIGO_SEQUENCE_PLACEHOLDER',
  TOOLTIP_TEXT_SCALE_DROPDOWN: 'TOOLTIP_TEXT_SCALE_DROPDOWN',
  TOOLTIP_TEXT_PURIFICATION_DROPDOWN: 'TOOLTIP_TEXT_PURIFICATION_DROPDOWN',
  NOTIFICATION_HEADER: 'NOTIFICATION_HEADER',
  SESSION_EXPIRED_MSG: 'SESSION_EXPIRED_MSG',
  SIGN_IN_OK_LABEL: 'SIGN_IN_OK_LABEL',
  UNABLE_TO_FULFIL_REQUEST_MSG: 'UNABLE_TO_FULFIL_REQUEST_MSG',
};

export type PlaceHolderKeys = {
  BULK_UPLOAD_URL: string;
  PLATE_OLIGO_URL: string;
  VALUE_OLIGO_URL: string;
  PROJECT_NUMBER: string;
  OLIGO_COUNT: string;
  INVALID_BASES: string;
  MIN_LENGTH: string;
  MAX_LENGTH: string;
  SHIP_BY_DATE: string;
  CUTOFF_COUNTDOWN: string;
  MAX_OLIGO_COUNT: string;
  DOWNLOAD_TEMPLATE_URL: string;
  SUPPORTED_TEMPLATE_EXTENSIONS: string;
  OLIGO_INDEX: string;
};

export const PlaceHolderKeys: PlaceHolderKeys = {
  BULK_UPLOAD_URL: 'BULK_UPLOAD_URL',
  PLATE_OLIGO_URL: 'PLATE_OLIGO_URL',
  VALUE_OLIGO_URL: 'VALUE_OLIGO_URL',
  PROJECT_NUMBER: 'PROJECT_NUMBER',
  OLIGO_COUNT: 'OLIGO_COUNT',
  INVALID_BASES: 'BASES',
  MIN_LENGTH: 'MIN_LENGTH',
  MAX_LENGTH: 'MAX_LENGTH',
  SHIP_BY_DATE: 'SHIP_BY_DATE',
  CUTOFF_COUNTDOWN: 'CUTOFF_COUNTDOWN',
  MAX_OLIGO_COUNT: 'MAX_OLIGO_COUNT',
  DOWNLOAD_TEMPLATE_URL: 'DOWNLOAD_TEMPLATE_URL',
  SUPPORTED_TEMPLATE_EXTENSIONS: 'SUPPORTED_TEMPLATE_EXTENSIONS',
  OLIGO_INDEX: 'OLIGO_INDEX',
};

export type ReplacePlaceHolders = (target: string, dict: Vocabulary) => string;
export const replacePlaceHolders: ReplacePlaceHolders = (target: string, dict: Vocabulary): string => {
  if (!target) {
    return '';
  }
  return Object.keys(dict).reduce((acc: string, key: string) => {
    const value: string = dict[key];
    return acc.replace(`{{${key}}}`, value);
  }, target);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/models/i18n.ts